import React from 'react';

var WebGameColMiddleWr = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: 'middle-inner-wrapper' }, children);
};

export { WebGameColMiddleWr };
